<template>
    <div class="bundles">
        <div class="bundle" v-for="(b, i) in data" :key="i" >
            <img class="art" :src="b.art" />
            <div class="bundle-content abs-center" >
                <div class="permissions v-m">
                    <div class="loyalty t-l">
                        <span class="impact loyalty-points fs-1-5">+{{ b.bp }}</span>
                    </div>
                    <div class="extra">
                        <div class="extra-icon t-c" >
                            <div><span class="extra-count impact fs-1-5">+{{ b.extra }}%</span></div>
                            <div><span class="impact fs-0-8 more-coins">{{ $t("message.moreCoins") }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="rewards">
                    <div class="reward-items">
                        <div class="reward-item t-l" v-if="b.coins" >
                            <div class="reward-count v-m">
                                <span class="coins segoe v-m fs-2">{{ fc(b.coins, 1) }}</span>
                            </div>
                        </div>
                        <div class="reward-item t-l" v-if="b.chips" >
                            <div class="reward-count v-m">
                                <span class="chips segoe v-m fs-2">{{ fc(b.chips, 2) }}</span>
                            </div>
                        </div>
                        <div class="reward-item t-l" >
                            <div class="reward-count v-m">
                                <span class="price segoe v-m fs-2">R${{ b.price }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="buy-now" >
                        <div class="btn buy-btn" @click.stop="buy(b.hash, b.currency, b.price)" ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '../../utils/utils.js';
export default {
    props: {
        data: Array,
        extra: Object
    },
    data() {
        return {
            utils: utils
        }
    },
    methods: {
        fc(currency, type) { return utils.fc(Math.round(currency * (1 + (type === 1 ? this.extra.coins: this.extra.chips)))) },
        buy(hash, currency, price) {
            this.$emit('buy', { "hash": hash, "currency": currency, "price": price })
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/css/variables.scss";
.bundles {

    .bundle {
        position: relative;
        max-width: 100%;
        display: inline-block;

        .art {
            max-width: inherit;
        }

        .bundle-content {
            box-sizing: border-box;
            padding: 0 68px;
            display: flex;
            flex-direction: row;
            width: 100%;
            height: 100%;

            .permissions {
                display: inline-block;
                flex-basis: 141px;
                color: #FFF;

                .loyalty {
                    width: 48%;
                    margin: 94px 0 0 auto;

                    .loyalty-points {
                        transform: translate(0, 0);
                        -webkit-transform: translate(0, 0);
                        text-shadow: 2px 2px #FF0037, 2px -2px #FF0037, -2px 2px #FF0037, -2px -2px #FF0037,
                            0 2px #FF0037, 0 -2px #FF0037, 2px 0 #FF0037, -2px 0 #FF0037;
                    }
                }

                .extra {
                    margin: 90px 0 0 0;

                    div {
                        font-size: 0;
                    }

                    span {
                        text-shadow: 2px 2px #FF1E02, 2px -2px #FF1E02, -2px 2px #FF1E02, -2px -2px #FF1E02,
                            0 2px #FF1E02, 0 -2px #FF1E02, 2px 0 #FF1E02, -2px 0 #FF1E02;
                    }

                    .extra-count {
                        line-height: 1.5rem;
                    }
                }
            }

            .rewards {
                flex: 1;
                width: 100%;
                height: 100%;

                .reward-items {
                    margin-top: 75px;
                    height: 237px;

                    .reward-item {
                        width: 60%;
                        height: 66px;
                        margin: 0 auto;
                        line-height: 66px;

                        .coins {
                            color: #F3F273;
                            text-shadow: 0 1px #000, 0 -1px #000, -1px 0 #000, 1px 0 #000,
                                1px 1px #000, 1px -1px #000, -1px 1px #000, -1px -1px #000;
                        }

                        .chips {
                            color: #03F513;
                            text-shadow: 0 2px #000, 0 -2px #000, -2px 0 #000, 2px 0 #000,
                                2px 2px #000, 2px -2px #000, -2px 2px #000, -2px -2px #000;
                        }

                        .price {
                            color: #FFF;
                            text-shadow: 0 2px #000, 0 -2px #000, -2px 0 #000, 2px 0 #000,
                                2px 2px #000, 2px -2px #000, -2px 2px #000, -2px -2px #000;
                        }
                    }
                }
            }

            .buy-now {
                height: 73px;

                .buy-btn {
                    display: inline-block;
                    width: 266px;
                    height: 100%;
                    border-radius: 100px;
                    margin: 0 0 0 -135px;
                }
            }
        }
    }
}

.mobile {

    .bundle {
        width: 100%;
        padding: 0;

        .bundle-content {
            padding: 0 3rem;

            .permissions {
                flex-basis: 7.9rem;

                .loyalty {
                    margin: 4.8rem 0 0 auto;

                    .loyalty-points {
                        text-shadow: 1px 1px #FF0037, 1px -1px #FF0037, -1px 1px #FF0037, -1px -1px #FF0037,
                            0 1px #FF0037, 0 -1px #FF0037, 1px 0 #FF0037, -1px 0 #FF0037;
                    }
                }

                .extra {
                    margin: 4.8rem 0 0 auto;

                    .more-coins {
                        display: inline-block;
                        transform: scale(.7);
                        -webkit-transform: scale(.7);
                    }

                    span {
                        line-height: 1rem;
                        text-shadow: 1px 1px #FF1E02, 1px -1px #FF1E02, -1px 1px #FF1E02, -1px -1px #FF1E02,
                            0 1px #FF1E02, 0 -1px #FF1E02, 1px 0 #FF1E02, -1px 0 #FF1E02;
                    }
                }
            }

            .rewards {

                .reward-items {
                    margin-top: 4rem;
                    height: 12.5rem;

                    .reward-item {
                        width: 78%;
                        height: 3.6rem;
                        line-height: 3.6rem;

                        .coins {
                            color: #F3F273;
                            text-shadow: 0 1px #000, 0 -1px #000, -1px 0 #000, 1px 0 #000,
                                1px 1px #000, 1px -1px #000, -1px 1px #000, -1px -1px #000;
                        }

                        .chips {
                            color: #03F513;
                            text-shadow: 0 1px #000, 0 -1px #000, -1px 0 #000, 1px 0 #000,
                                1px 1px #000, 1px -1px #000, -1px 1px #000, -1px -1px #000;
                        }

                        .price {
                            color: #FFF;
                            text-shadow: 0 1px #000, 0 -1px #000, -1px 0 #000, 1px 0 #000,
                                1px 1px #000, 1px -1px #000, -1px 1px #000, -1px -1px #000;
                        }
                    }
                }
            }

            .buy-now {
                height: 3.9rem;

                .buy-btn {
                    width: 13.8rem;
                    margin: 0 0 0 -7.6rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/bundles.vue